import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Bredcrumb from '../../HomeMain/Bredcrumb'
import RelatedServices from '../RelatedServices'
import { cld } from '../../../utils/cld'

const ImgLips1 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758316308/IMG_0730_aaisyt.jpg"
const ImgLips2 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758316308/IMG_0731_hf1nux.jpg"
const ImgLips3 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758316308/IMG_0718_jq1sqt.jpg"

const callBtnStyle = {
  display: "inline-block",
  padding: "15px 35px",
  backgroundColor: "#90510F",
  color: "#ffffffff",
  fontWeight: "600",
  fontSize: "1.2rem",
  borderRadius: "8px",
  textDecoration: "none",
  border: "1px solid #ddd",
  transition: "transform 0.3s",
}

const Main = () => {
  const { t } = useTranslation()

  const sidebarLinks = [
    { to: "/makeup",           label: t('servicesSidebar.makeup'),          active: false },
    { to: "/permanent-makeup", label: t('servicesSidebar.permanentMakeup'), active: false },
    { to: "/vega",             label: t('servicesSidebar.vega'),            active: false },
    { to: "/baby-lips",        label: t('servicesSidebar.babyLips'),        active: true  },
    { to: "/eyelashes",        label: t('servicesSidebar.eyelashes'),       active: false },
    { to: "/nails",            label: t('servicesSidebar.nails'),           active: false },
    { to: "/depilation",       label: t('servicesSidebar.depilation'),      active: false },
    { to: "/hairdresser",      label: t('servicesSidebar.hairdresser'),     active: false },
  ]

  const ContactBox = () => (
    <div className="service-detail-contact wow fadeup-animation" data-wow-delay="1.1s">
      <h3 className="h3-title">{t('servicesSidebar.contactTitle')}</h3>
      <a
        href="tel:0653585545"
        style={callBtnStyle}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        {t('servicesSidebar.callNow')}
      </a>
    </div>
  )

  return (
    <>
      <Bredcrumb title={t('babyLipsService.breadcrumbTitle')} subtitle={t('babyLipsService.breadcrumbSubtitle')} />

      <div className="about-area5 about-p p-relative">
        <div className="container pt-120 pb-90">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-4 order-1">
              <aside className="sidebar services-sidebar">
                <div className="sidebar-widget categories">
                  <div className="widget-content">
                    <ul className="services-categories">
                      {sidebarLinks.map(({ to, label, active }) => (
                        <li key={to} className={active ? 'active' : ''}>
                          <Link to={to}>{label} <i className="fa fa-arrow-right"></i></Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="d-none d-lg-block">
                  <ContactBox />
                </div>
              </aside>
            </div>
            <div className="col-lg-8 col-md-12 col-sm-12 order-2">
              <div className="service-detail">
                <div className="content-box">
                  <h2>{t('babyLipsService.h2')}</h2>
                  <p>{t('babyLipsService.p1')}</p>
                  <div className="two-column">
                    <div className="row">
                      <div className="image-column col-xl-6 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(ImgLips1, { w: 1100 })} alt="lips" width="1100" height="727" loading="lazy" decoding="async" /></figure>
                      </div>
                      <div className="text-column col-xl-6 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(ImgLips2, { w: 1100 })} alt="lips" width="1100" height="711" loading="lazy" decoding="async" /></figure>
                      </div>
                    </div>
                  </div>
                  <p>{t('babyLipsService.p2')}</p>

                  <h3>{t('babyLipsService.whoTitle')}</h3>
                  <ul>
                    {t('babyLipsService.whoItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('babyLipsService.processTitle')}</h3>
                  <ul>
                    {t('babyLipsService.processItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>{i + 1}. {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('babyLipsService.benefitsTitle')}</h3>
                  <ul>
                    {t('babyLipsService.benefitsItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('babyLipsService.aftercareTitle')}</h3>
                  <ul>
                    {t('babyLipsService.aftercareItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <h3>{t('babyLipsService.resultTitle')}</h3>
                  <ul>
                    {t('babyLipsService.resultItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>- {item}</li>
                    ))}
                  </ul>
                  <br />

                  <div className="two-column">
                    <div className="row">
                      <div className="image-column col-xl-12 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(ImgLips3, { w: 1100 })} alt="lips" width="1100" height="729" loading="lazy" decoding="async" /></figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RelatedServices items={[{ to: "/permanent-makeup", labelKey: "servicesSidebar.permanentMakeup" }, { to: "/vega", labelKey: "servicesSidebar.vega" }]} />
          <div className="row d-lg-none">
            <div className="col-12">
              <ContactBox />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Main
